import React, { useState } from "react"
import { CustomElementDataSourceTable } from "./DataSourceTable";
import { CustomElementDataSourceForm } from "./DataSourceForm";
export const CustomElementDataSourceMain = () => {

    const [newOrEditDialog, setNewOrEditDialog] = useState(false);
    const [dataId, setDataId] = useState(0);

    const onBackToTable = () => {
        setDataId(0);
        setNewOrEditDialog(false);
    }
    
    return (
        <>
            {!newOrEditDialog && (
                <CustomElementDataSourceTable 
                    onRowClickHandler={(id: number) => {
                        setDataId(id);
                        setNewOrEditDialog(true);
                    }}
                    onAddClickHandler={() => {
                        setDataId(0);
                        setNewOrEditDialog(true);
                    }}
                />
            )}
            {newOrEditDialog && (
                <CustomElementDataSourceForm id={dataId} onBackToTable={onBackToTable}/>
            )}
        </>
    )
}